import * as React from "react";
import { type FC } from "react";
import { Input, InputProps } from "react-ui";

type RestInputProps = Omit<InputProps, "onValueChange" | "onChange">;

interface AddressFieldProps extends RestInputProps {
    onChange: (next: string) => void;
}

export const AddressField: FC<AddressFieldProps> = ({ value, onChange, ...restProps }) => (
    <Input value={value} onValueChange={onChange} {...restProps} />
);
